	
	/* Open search box results */
	const	openSearchBox = document.getElementById( 'search-box-open' ),
			closeSearchBox = document.querySelectorAll( '.search-box__button-close' ),
			searchBox = document.getElementById( 'search-box-content' );

	if ( openSearchBox && closeSearchBox && searchBox ) {

		openSearchBox.addEventListener( 'click', function(e) {

			searchBox.classList.toggle( 'search-box--open' );
			searchBox.setAttribute( 'aria-expanded', searchBox.classList.contains( 'search-box--open' ) );
			openSearchBox.setAttribute( 'aria-expanded', searchBox.classList.contains('search-box--open') );
			
		} );

		closeSearchBox.forEach( function( closeButton ) {

			closeButton.addEventListener( 'click', function(e) {

				searchBox.classList.remove( 'search-box--open' );
				searchBox.setAttribute( 'aria-expanded', false );
				openSearchBox.setAttribute( 'aria-expanded', false );

			} );
			
		} );

	}
	